function initialiseHelpImages () {
  const overlayContainer = document.querySelector('.fs-images-overlay-container')
  const overlay = overlayContainer?.querySelector('.fs-help-image-overlay')
  const images = document.querySelectorAll('.fs-help-image')

  if (!overlayContainer || !overlay || !images.length) {
    return
  }

  function closeImage () {
    overlay.classList.remove('fs-help-image-overlay-display')
    overlayContainer
      .querySelector('.help-fs-image-container:not(.hidden)')
      ?.classList.add('hidden')
  }

  images.forEach((image, index) => {
    const imageId = String(index)
    const fullSizeImage = image.cloneNode()
    const fullSizeImageContainer = document.createElement('div')

    image.setAttribute('help-image-id', imageId)
    fullSizeImageContainer.classList.add('hidden', 'help-fs-image-container')
    fullSizeImageContainer.setAttribute('help-image-id', imageId)
    fullSizeImageContainer.appendChild(fullSizeImage)
    overlayContainer.appendChild(fullSizeImageContainer)

    image.addEventListener('click', () => {
      overlay.classList.add('fs-help-image-overlay-display')
      fullSizeImageContainer.classList.remove('hidden')
    })
  })

  overlay.addEventListener('click', closeImage)
}

window.addEventListener('DOMContentLoaded', initialiseHelpImages)

module.exports = initialiseHelpImages
